import EmailActivityAttachment from './EmailActivityAttachment';

export default EmailActivityAttachment;
